class QuickAddModel extends HTMLElement {
    constructor() {
        super();
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        document.addEventListener('custom:cart-update', (e) => {
            this.cart.renderContents(e.detail);
            // this.handleCartUpdate(e.detail);
        });

    }
}

customElements.define('my-modal', QuickAddModel);